module.exports = __webpack_public_path__ + "static/media/ic-eletricidade.daf2f299.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Equipments/images/ic-eletricidade.svg
// module id = 1229
// module chunks = 0